/**
 * Utility functions for encoding/decoding global IDs
 */

const encode = (str: string): string => {
  return process.client ? btoa(str) : Buffer.from(str).toString('base64')
}

const decode = (str: string): string => {
  return process.client ? atob(str) : Buffer.from(str, 'base64').toString('utf8')
}

export function generateGlobalId(prefix: string, hashId: string): string {
  if (!prefix || !hashId) {
    throw new Error('Prefix and hashId are required')
  }
  return encode(`${prefix}:${hashId}`)
}

export function extractHashId(globalId: string): string {
  if (!globalId) {
    throw new Error('Global ID is required')
  }
  return decode(globalId).split(':')[1] || ''
}
